import {
  Button,
  Checkbox,
  CheckboxProps,
  Flex,
  Form,
  Input,
  Select,
  Skeleton,
  Upload,
  UploadProps,
} from "antd";
import MaskedInput from "antd-mask-input";
import PhoneInput from "react-phone-input-2";
import { usePaises } from "../../../hooks/usePaises";
import { useEstados } from "../../../hooks/useEstados";
import { useCidades } from "../../../hooks/useCidades";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  btnStyle,
  CheckBoxContainer,
  ContainerModal,
  ContainerModalArquivo,
  formStyle,
  TextModal,
} from "../styles";
import { layout } from "../../ViewGerenciarPropriedadeUsuario/constant/layout";
import { filterOption, filterSort } from "../../../uteis/filtroSelect";
import { EstadoCivil } from "../../../interfaces/EstadoCivil";
import { UploadOutlined } from "@ant-design/icons";
import { useFileUpload } from "../../../hooks/useUploadFiles";
import { Usuario } from "../../../interfaces/Usuario";
import { Endereco } from "../../../interfaces/Endereco";
import { Pais } from "../../../interfaces/Pais";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
import { useMessage } from "../../../uteis/mensagens/useMessage";

const estadoCivilOpcoes = [
  //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
  { id: 1, label: "Solteiro", value: "SOLTEIRO" },
  { id: 2, label: "Casado", value: "CASADO" },
  { id: 3, label: "Separado", value: "SEPARADO" },
  { id: 4, label: "Divorciado", value: "DIVORCIADO" },
  { id: 5, label: "Viúvo", value: "VIUVO" },
];

const estadoCivil: EstadoCivil[] = estadoCivilOpcoes.map((ec) => ({
  // Map do array
  id: ec.id,
  label: ec.label,
  value: ec.value,
}));

interface FormValidacaoProprietarioProps {
  cotaUsuarioId: number;
  setCadastroProprietario: Dispatch<SetStateAction<Partial<Usuario>>>;
  setEnderecoProprietario: Dispatch<SetStateAction<Partial<Endereco>>>;
  setCadastroRepresentante: Dispatch<SetStateAction<Partial<Usuario>>>;
  setEnderecoRepresentante: Dispatch<SetStateAction<Partial<Endereco>>>;
  setRepresentante: Dispatch<SetStateAction<boolean>>;
  representante: boolean;
}

export default function FormValidacaoProprietario({
  cotaUsuarioId,
  setCadastroProprietario,
  setEnderecoProprietario,
  setCadastroRepresentante,
  setEnderecoRepresentante,
  setRepresentante,
  representante,
}: FormValidacaoProprietarioProps) {
  const [formDadosProprietario] = Form.useForm();
  const [formDadosRepresentante] = Form.useForm();

  // UseState para armazenar o ID do estado selecionado
  const [estadoSelecionados, setEstadoSelecionadoId] = useState<
    number | undefined
  >(undefined);

  // UseState para armazenar o telefone digitado
  const [phone, setPhone] = useState<string>("");

  // Use para buscar as cidades do Estado Selecionado
  const {
    isLoading: isLoadingPaises,
    data: paises,
    error: errorPaises,
  } = usePaises();

  // Use para buscar as cidades do Estado Selecionado
  const {
    isLoading: isLoadingEstados,
    data: estados,
    error: errorEstados,
  } = useEstados();

  // Use para buscar as cidades do Estado Selecionado
  const {
    isLoading: isLoadingCidades,
    data: cidades,
    error: errorCidades,
  } = useCidades(estadoSelecionados);

  // Usando o hook
  const {
    fileList,
    uploading,
    handleRemove,
    beforeUpload,
    handleUpload,
    error: arquivoError,
    success: arquivoSuccess,
    resetError,
    resetSuccess,
  } = useFileUpload(cotaUsuarioId);

  const props: UploadProps = {
    onRemove: handleRemove,
    beforeUpload,
    fileList,
  };

  const representanteChange: CheckboxProps["onChange"] = (e) => {
    const isChecked = e.target.checked;
    setRepresentante(isChecked);
    if (!isChecked) {
      formDadosProprietario.resetFields();
    }
  };

  const cadastrarProprietario = (
    changedValues: Partial<Usuario & Endereco>, // <- ajusta aqui também!
    allValues: Usuario & Endereco
  ) => {
    setCadastroProprietario({
      nome: allValues.nome,
      sobrenome: allValues.sobrenome,
      cpf: allValues.cpf,
      email: allValues.email,
      celular: numberPadrao(allValues.celular),
      nacionalidade: allValues.nacionalidade,
      estadoCivil: allValues.estadoCivil,
    });

    setEnderecoProprietario({
      endereco: allValues.endereco,
      complemento: allValues.complemento,
      cidadeId: allValues.cidadeId,
      estadoId: allValues.estadoId,
      paisId: allValues.paisId,
    });
  };

  const cadastrarRepresentante = (
    changedValues: Partial<Usuario>,
    allValues: Usuario & Endereco
  ) => {
    setCadastroRepresentante({
      nome: allValues.nome,
      sobrenome: allValues.sobrenome,
      cpf: allValues.cpf,
      email: allValues.email,
      celular: numberPadrao(allValues.celular),
      nacionalidade: allValues.nacionalidade,
      estadoCivil: allValues.estadoCivil,
    });

    setEnderecoRepresentante({
      endereco: allValues.endereco,
      complemento: allValues.complemento,
      cidadeId: allValues.cidadeId,
      estadoId: allValues.estadoId,
      paisId: allValues.paisId,
    });
  };

  // Função que armazena o id do pais selecionado para a atualização de cadastro e cadastro do proprietario
  const paisChange = (
    id: number,
    form: "formDadosProprietario" | "formDadosRepresentante"
  ) => {
    const paisSelecionado = paises?.find((pais) => pais.id === id);

    if (paisSelecionado) {
      if (form === "formDadosProprietario") {
        formDadosProprietario.setFieldsValue({
          nacionalidade: paisSelecionado.abreviacao,
          paisId: paisSelecionado.id,
        });

        setCadastroProprietario((prevState) => ({
          ...prevState,
          nacionalidade: paisSelecionado.abreviacao,
        }));

        setEnderecoProprietario((prevState) => ({
          ...prevState,
          paisId: paisSelecionado.id,
        }));
      }

      if (form === "formDadosRepresentante") {
        formDadosRepresentante.setFieldsValue({
          nacionalidade: paisSelecionado.abreviacao,
          paisId: paisSelecionado.id,
        });

        setCadastroRepresentante((prevState) => ({
          ...prevState,
          nacionalidade: paisSelecionado.abreviacao,
        }));

        setEnderecoRepresentante((prevState) => ({
          ...prevState,
          paisId: paisSelecionado.id,
        }));
      }
    }
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  // Exibe a Mensagem de  Erro
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (arquivoSuccess && !successDisplayed) {
      showSuccess(arquivoSuccess);
      setSuccessDisplayed(true);
      setTimeout(() => {
        resetSuccess(); // ✅
      }, 3000);
    }

    if (arquivoError && !errorDisplayed) {
      showError(arquivoError);
      setErrorDisplayed(true);
      setTimeout(() => {
        resetError(); // ✅
      }, 3000);
    }
  }, [
    arquivoError,
    arquivoSuccess,
    resetError,
    resetSuccess,
    successDisplayed,
    errorDisplayed,
  ]);
  return (
    <>
      {isLoadingEstados && isLoadingPaises && <Skeleton active />}
      {!isLoadingEstados && !isLoadingPaises && (
        <ContainerModal>
          {contextHolder}
          <>
            {/* <Form
              {...layout}
              form={formDadosProprietario}
              onValuesChange={(changedValues, allValues) =>
                cadastrarProprietario(changedValues, allValues)
              }
              name="dados-proprietario"
              style={formStyle}
            >
              <TextModal>Cadastrar Proprietário</TextModal>
              <Form.Item name={["nome"]} label="Nome" className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["sobrenome"]}
                label="Sobrenome"
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item name={["cpf"]} label="CPF" className="formItems">
                <Input />
              </Form.Item>
              <Form.Item name={["email"]} label="E-mail" className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["celular"]}
                label="Celular"
                className="formItems"
              >
                <Input placeholder="(00) 00000-0000" />
              </Form.Item>
              <Form.Item name="paisId" hidden>
                <Input type="hidden" />
              </Form.Item>

              <Form.Item
                name={["nacionalidade"]}
                label="Nacionalidade"
                className="formItems"
              >
                <Select
                  showSearch
                  className="selectPaises"
                  onChange={(value) =>
                    paisChange(value, "formDadosProprietario")
                  }
                  placeholder="Selecione a nacionalidade"
                  optionFilterProp="children"
                  filterOption={filterOption}
                  filterSort={filterSort}
                >
                  {paises?.map((pais) => (
                    <Select.Option key={pais.id} value={pais.id}>
                      {pais.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["estadoCivil"]}
                label="Estado Civil"
                className="formItems"
              >
                <Select>
                  {estadoCivil.map((ec, index) => (
                    <Select.Option key={ec.id} value={ec.value}>
                      {ec.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["endereco"]}
                label="Endereço"
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["complemento"]}
                label="Complemento"
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name={["estadoId"]}
                label="Estado"
                className="formItems"
              >
                <Select
                  showSearch
                  className="selectCidades"
                  placeholder="Selecione o estado"
                  optionFilterProp="children"
                  filterOption={filterOption}
                  filterSort={filterSort}
                  onChange={(value) => setEstadoSelecionadoId(value)}
                >
                  {estados?.map((estados) => (
                    <Select.Option key={estados.id} value={estados.id}>
                      {estados.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["cidadeId"]}
                label="Cidade"
                className="formItems"
              >
                <Select
                  showSearch
                  className="selectCidades"
                  placeholder="Selecione a cidade"
                  optionFilterProp="children"
                  filterOption={filterOption}
                  filterSort={filterSort}
                  disabled={
                    isLoadingCidades || !cidades || cidades.length === 0
                  }
                >
                  {cidades?.map((cidade) => (
                    <Select.Option key={cidade.id} value={cidade.id}>
                      {cidade.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form> */}

            {representante ? (
              <>
                {" "}
                <Form
                  {...layout}
                  form={formDadosRepresentante}
                  onValuesChange={(changedValues, allValues) =>
                    cadastrarRepresentante(changedValues, allValues)
                  }
                  name="dados-representante"
                  style={formStyle}
                >
                  <TextModal>Cadastrar Representante</TextModal>
                  <Form.Item name={["nome"]} label="Nome" className="formItems">
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name={["sobrenome"]}
                    label="Sobrenome"
                    className="formItems"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item name={["cpf"]} label="CPF" className="formItems">
                    <MaskedInput mask="000.000.000-00" />
                  </Form.Item>
                  <Form.Item
                    name={["email"]}
                    label="E-mail"
                    className="formItems"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name={["celular"]}
                    label="Celular"
                    className="formItems"
                  >
                    <PhoneInput
                      country={"br"}
                      value={phone}
                      onChange={handlePhoneChange}
                      placeholder="Digite seu telefone"
                      inputClass="phone-input"
                    />
                  </Form.Item>
                  <Form.Item
                    name={["nacionalidade"]}
                    label="Nacionalidade"
                    className="formItems"
                  >
                    <Select
                      showSearch
                      className="selectPaises"
                      onChange={(value) =>
                        paisChange(value, "formDadosRepresentante")
                      }
                      placeholder="Selecione a nacionalidade"
                      optionFilterProp="children"
                      filterOption={filterOption}
                      filterSort={filterSort}
                    >
                      {paises?.map((pais) => (
                        <Select.Option key={pais.id} value={pais.abreviacao}>
                          {pais.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={["estadoCivil"]}
                    label="Estado Civil"
                    className="formItems"
                  >
                    <Select>
                      {estadoCivil.map((ec, index) => (
                        <Select.Option key={ec.id} value={ec.value}>
                          {ec.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={["endereco"]}
                    label="Endereço"
                    className="formItems"
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name={["complemento"]}
                    label="Complemento"
                    className="formItems"
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name={["estadoId"]}
                    label="Estado"
                    className="formItems"
                  >
                    <Select
                      showSearch
                      className="selectCidades"
                      placeholder="Selecione o estado"
                      optionFilterProp="children"
                      filterOption={filterOption}
                      filterSort={filterSort}
                      onChange={(value) => setEstadoSelecionadoId(value)}
                    >
                      {estados?.map((estados) => (
                        <Select.Option key={estados.id} value={estados.id}>
                          {estados.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name={["cidadeId"]}
                    label="Cidade"
                    className="formItems"
                  >
                    <Select
                      showSearch
                      className="selectCidades"
                      placeholder="Selecione a cidade"
                      optionFilterProp="children"
                      filterOption={filterOption}
                      filterSort={filterSort}
                      disabled={
                        isLoadingCidades || !cidades || cidades.length === 0
                      }
                    >
                      {cidades?.map((cidade) => (
                        <Select.Option key={cidade.id} value={cidade.id}>
                          {cidade.nome}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
              </>
            ) : null}
            <CheckBoxContainer>
              <Checkbox
                checked={representante}
                onChange={representanteChange}
                style={{ fontWeight: "bold", color: "#4A4A4A" }}
              >
                {representante
                  ? "Desvincular o representante da propriedade"
                  : "Vincular a propriedade a um representante"}
              </Checkbox>
            </CheckBoxContainer>
            {/* <ContainerModalArquivo>
              <TextModal>Atualizar Arquivos</TextModal>
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>
                  Clique para carregar arquivo
                </Button>
              </Upload>

              <Flex align="center" justify="center">
                <Button
                  type="primary"
                  onClick={handleUpload}
                  loading={uploading}
                  style={btnStyle}
                  size="large"
                >
                  {uploading ? "Uploading" : "Anexar"}
                </Button>
              </Flex>
            </ContainerModalArquivo> */}
          </>
        </ContainerModal>
      )}
    </>
  );
}
